<div class="portfolio-wrapper" [class.no-filter-bar]="currentTab !== 'media'">
	<div class="breadcrumb-bar-outer">
		<div class="breadcrumb-bar">
			<ng-container *ngIf="parentEntity">
				<ng-container *ngIf="parentEntity?.type === 'App'">
					<div class="breadcrumb-parts have-project">
						<div class="breadcrumb-inner">
							<bb-entity-selector theme="dark"
								title="Project from which you can select contexts"
								[placeholder]="('SELECT_PROJECT' | translate) + '...'"
								[entityType]="'project'" [disableClear]="true" [(ngModel)]="templateProjectId"
								name="templateProjectId" (ngModelChange)="onProjectChange()"></bb-entity-selector>
						</div>
						<div class="breadcrumb-inner with-button">
							<span [innerHTML]="'app' | widgetIcon" class="ie-icon-display"></span>
							<span class="ellipsed">
								{{ parentEntity?.name }}
							</span>
						</div>
						<span class="ie-icon-button right-button" (click)="editApp(parentEntity)" [title]="'EDIT_TEMPLATE' | translate">
							<i class="fa fa-pencil"></i>
						</span>
					</div>
				</ng-container>
				
				<ng-container *ngIf="parentEntity?.type === 'MediaClip'">
					<div class="breadcrumb-parts" [class.have-project]="interactivityEditorService?.parentProject?.id">
						<div class="breadcrumb-inner" *ngIf="interactivityEditorService?.parentProject">
							<span class="ie-icon-display">
								<i class="fa fa-paper-plane"></i>
							</span>
							<a
								class="ellipsed"
								[title]="'EDIT_PROJECT' | translate"
								[routerLink]="['/library/project/', interactivityEditorService?.parentProject?.id, 'flowchart']"
							>{{ interactivityEditorService?.parentProject?.title || interactivityEditorService?.parentProject?.name }}</a>
						</div>
						<div class="breadcrumb-inner">
							<span [innerHTML]="parentEntity.mediatype | mediatypeIcon" class="ie-icon-display"></span>
							<a
								class="ellipsed"
								[title]="(parentEntity?.subusetype && parentEntity?.subusetype?.indexOf('vast_creative') > -1 ? 'EDIT_VAST_CREATIVE' : 'EDIT_MEDIACLIP') | translate"
								[routerLink]="[(parentEntity?.subusetype && parentEntity?.subusetype?.indexOf('vast_creative') > -1 ? '/adservices/vastservice/creatives/' : '/library/mediaclip/'), parentEntity?.id ]"
							>{{ parentEntity?.title || parentEntity?.originalfilename }}</a>
						</div>
					</div>
				</ng-container>
				
				<ng-container *ngIf="parentEntity?.type === 'Project'">
					<div class="breadcrumb-inner">
						<span class="ie-icon-display">
							<i class="fa fa-paper-plane"></i>
						</span>
						<a
							class="ellipsed"
							[title]="'EDIT_PROJECT' | translate"
							[routerLink]="['/library/project/', parentEntity?.id ]"
						>{{ parentEntity?.title || parentEntity?.name }}</a>
					</div>
				</ng-container>
				
			</ng-container>
		</div>
	</div>

	<div class="search-bar">
		<input type="text" [(ngModel)]="searchQuery" (change)="onSearchInputChange(searchQuery)" [placeholder]="'SEARCH' | translate | lowercase" />
		<i class="fa fa-search"></i>
	</div>
	<div class="filter-bar"
	[hidden]="currentTab !== 'media'">
		<div class="filter-buttons">
			<ng-container *ngFor="let preset of filterConfig?.presets">
				<div
					(click)="onFilterClick(preset)"
					class="filter-button"
					[class.active]="activeFilterPreset === preset.value"
				>
					<span class="icon" *ngIf="!preset?.label" [innerHtml]="preset.value | widgetIcon"></span>
			</div>
			</ng-container>
		</div>
		<bb-upload [createNewMediaclip]="true" [publishCreatives]="true" [multi]="true" [hideDropText]="true" [uploadText]="'UPLOAD' | translate"></bb-upload>
	</div>


	<div class="properties" hide-in-percy>
		<div class="content-scroll">

			<ng-container *ngIf="currentTab === 'media'" >
				<bb-table-container class="media-table">
					<bb-table-row [theme]="'darkTheme'"
					[style.pointer-events]="row?.data?.isEmpty ? 'none' : 'inherit'"
					draggable="true"
					(dragstart)="onRowDragStart(row, $event)"
					(contextmenu)="onMediaContextMenu($event, row)"
					*ngFor="let row of rows; let i = index" 
					[row]="row"
					>
						<bb-table-cell class="thumb" [theme]="'darkTheme'"><span [innerHTML]="row.data | thumbnail : 50:28 | async" *ngIf="!row.data?.isEmpty"></span></bb-table-cell>
						<bb-table-cell class="overflow" [theme]="'darkTheme'">
							<!-- {{ row.data.title || row.data.originalfilename }} -->
							<span [hidden]="!row.data.title">{{ row.data.title }}</span>
							<span [hidden]="row.data.title" class="filename">{{ row.data.originalfilename }}</span>
						</bb-table-cell>
						<bb-table-cell [theme]="'darkTheme'"><span class="icon" [innerHTML]="row.data | clipIcon"></span></bb-table-cell>
					</bb-table-row>
				</bb-table-container>
				<bb-table-pager [theme]="'darkTheme'"></bb-table-pager>
			</ng-container>
			
			<ng-container *ngIf="currentTab === 'assets'">

			</ng-container>
			
			<div *ngIf="currentTab === 'templates'"><!-- F.K.A. APPS -->
				<bb-table-container>
					<bb-table-row [theme]="'darkTheme'"
					draggable="true"
					(dragstart)="onRowDragStart(row, $event)"
					(contextmenu)="onMediaContextMenu($event, row)"
					*ngFor="let row of rows; let i = index" 
					[row]="row"
					>
						<bb-table-cell class="overflow" [theme]="'darkTheme'" [title]="'DRAG_ON_STAGE_TO_USE_TEMPLATE' | translate">{{ row.data.name }}</bb-table-cell>
						<bb-table-cell class="buttons" [theme]="'darkTheme'"><!--

							--><a class="button"
							[title]="'OPEN_INTERACTIVE_LAYER' | translate"
							[hasPermission]="'root'"
							[class.disabled]="!row.data.timelines || !row.data.timelines[0]"
							[routerLink]="['/library/interactivity/', row.data.timelines && row.data.timelines[0] && (row.data.timelines[0].id || row.data.timelines[0]) ]">
								<i class="fa fa-object-group"></i>
							</a><!-- 

							--><a
							class="button"
							[title]="'IMPORT_INTERACTIVE_LAYER' | translate"
							(click)="importTimeline((row.data.timelines[0].id || row.data.timelines[0]), row.data)"
							[class.disabled]="!row.data.timelines || !row.data.timelines[0]"
							>
								<i class="fa fa-arrow-right"></i>
							</a>
						</bb-table-cell>
					</bb-table-row>
				</bb-table-container>
				<bb-table-pager [theme]="'darkTheme'"></bb-table-pager>
				<div class="add-new-template">
					<span class="button" (click)="createNewApp()">{{ 'CREATE_NEW_TEMPLATE' | translate }}</span>
				</div>
			</div>
			
			<div *ngIf="currentTab === 'timelines'"> <!--// (click)="showStateHistory = true;"> -->
				<bb-table-container>
					<bb-table-row [theme]="'darkTheme'"
					*ngFor="let row of rows; let i = index" 
					[row]="row"
					>
						<bb-table-cell class="thumb" [theme]="'darkTheme'"><span [innerHTML]="row.data | thumbnail : 50:28 | async"></span></bb-table-cell>
						<bb-table-cell class="overflow" [theme]="'darkTheme'">
							<!-- {{ row.data.title || row.data.originalfilename }} -->
							<span [hidden]="!row.data.title">{{ row.data.title }}</span>
							<span [hidden]="row.data.title" class="filename">{{ row.data.originalfilename }}</span>
						</bb-table-cell>
						<bb-table-cell [theme]="'darkTheme'"><span class="icon" [innerHTML]="row.data | clipIcon"></span></bb-table-cell>
						<bb-table-cell class="buttons" [theme]="'darkTheme'"><!--

						--<a class="button" [routerLink]="['/library/mediaclip/', row.data.id, 'metadata']">
								<i class="fa fa-edit"></i>
							</a><!--

							--><a class="button"
							[title]="'OPEN_INTERACTIVE_LAYER' | translate"
							[hasPermission]="'root'"
							[class.disabled]="!row.data.timelines || !row.data.timelines[0]"
							[routerLink]="['/library/interactivity/', row.data.timelines && row.data.timelines[0]]">
								<i class="fa fa-object-group"></i>
							</a><!-- 

							--><a
							class="button"
							[title]="'IMPORT_INTERACTIVE_LAYER' | translate"
							(click)="importTimeline(row.data.timelines[0], row.data)"
							[class.disabled]="!row.data.timelines || !row.data.timelines[0]"
							>
								<i class="fa fa-arrow-right"></i>
							</a>
						</bb-table-cell>
					</bb-table-row>
				</bb-table-container>
				<bb-table-pager [theme]="'darkTheme'"></bb-table-pager>
			</div>

		</div>
	</div>

	<bb-context-menu [ngStyle]="contextMenuStyle" [themeName]="'dark-theme'" [options]="contextMenuOptions" (optionSelected)="onContextMenuOptionSelected($event)" (clickOutside)="contextMenuHide()"></bb-context-menu>

	<div class="tab-buttons">
		<div (click)="setTab('media')" class="tab-button" [class.active]="currentTab === 'media'">
			<i class="fa fa-book button-icon"></i><br />
			<span class="button-text">{{ 'MEDIA' | translate }}</span>
		</div>
		<!-- <div (click)="setTab('assets')" class="tab-button" [class.active]="currentTab === 'assets'">
			<i class="fa fa-paper-plane button-icon"></i><br />
			<span class="button-text">{{ 'ASSETS' | translate }}</span>
		</div> -->
		<div (click)="setTab('templates')" class="tab-button" [class.active]="currentTab === 'templates'">
			<i class="fa fa-cube button-icon"></i><br />
			<span class="button-text">{{ 'TEMPLATES' | translate }}</span>
		</div>
		<div (click)="setTab('timelines')" class="tab-button" [class.active]="currentTab === 'timelines'">
			<i class="fa fa-cubes button-icon"></i><br />
			<span class="button-text">{{ 'TIMELINES' | translate }}</span>
		</div>
	</div>
</div>

<bb-upload class="upload-dropzone" [dropZoneOnly]="true" [createNewMediaclip]="true" [publishCreatives]="true" [multi]="true" [hideDropText]="true" [uploadText]="'UPLOAD' | translate"></bb-upload>

<ng-template #editAppTemplate>
	<bb-edit-app
		[app]="parentEntity"
		[modal]="appModal"
	></bb-edit-app>
</ng-template>

<ng-template #createAppTemplate>
	<bb-edit-app
		[modal]="appModal"
	></bb-edit-app>
</ng-template>
